export default __webpack_public_path__ + "static/description-6cda185165d67076435a36b91dfe5cc3.webp";